import apiClient from '@/services/axios'

class PrivilegeService {
  async exportPrivileges() {
    const url = '/admin/privilege/export'
    return apiClient.get(url)
  }

  async getPrivileges(searchParams) {
    const url = `/admin/privilege?${searchParams}`
    return apiClient.get(url)
  }

  async getPrivilege(privilegeId) {
    const url = `/admin/privilege/${privilegeId}`
    return apiClient.get(url)
  }

  async createPrivilege(data) {
    const url = '/admin/privilege'
    return apiClient.post(url, data)
  }

  async updatePrivilege(privilegeId, data) {
    const url = `/admin/privilege/${privilegeId}`
    return apiClient.put(url, data)
  }

  async deletePrivilege(privilegeId) {
    const url = `/admin/privilege/${privilegeId}`
    return apiClient.delete(url)
  }

  async uploadPrivilegeImage(file) {
    const formData = new FormData()
    formData.append('cover', file)

    const url = '/admin/privilege/cover'
    return apiClient.post(url, formData)
  }

  async changePrivilegeStatus(privilegeId, data) {
    const url = `/admin/privilege/${privilegeId}`
    return apiClient.put(url, data)
  }
}

export default new PrivilegeService()
